import { GroupMessages } from '@/routes/messages/groups/by-id';
import { SessionMessages } from '@/routes/messages/sessions/by-id';
import { useMessageStore } from '@/stores/message';
import { parseSessionKey } from '@/utils/session';

export default function DesktopRightSection() {
  const { key: sessionKey } = useMessageStore();
  if (sessionKey !== 'default') {
    const [type, id] = parseSessionKey(sessionKey);
    return type === 'session' ? <SessionMessages sessionId={id} /> : <GroupMessages groupId={id} />;
  }

  return null;
}
